import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import { clearUpdatedApplication, updateApplication } from '../../../store/actions/applicationsActions'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import SelectField from '../../elements/form/SelectField'
import TrashIcon from '../../elements/icons/TrashIcon'
import PlusIcon from '../../elements/icons/PlusIcon'
import { fetchExaminationCenters } from '../../../store/actions/examinationCentersActions'

const NewExaminationSchedule = ({application, closeFunction, reload, description}) => {
    const dispatch = useDispatch()
    const applicationsSelector = useSelector((state => state.applications))
    const examinationsSelector = useSelector(state => state.examinations)
    const examinationCentersSelector = useSelector(state => state.examinationCenters)

    const [schedulePayload, setSchedulePayload] = useState({
        status: 'SCHEDULED_FOR_EXAM',
        scheduledExaminations: [{
            examination: '', 
            center: application.preferredCenter || ''
        }]
    });
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        dispatch(fetchExaminationCenters('', 0, 0))
        if(applicationsSelector.updatedApplication){
            dispatch({
                type: SET_SUCCESS,
                payload: 'exam scheduled successfully for examination!'
            })
            dispatch(clearUpdatedApplication())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
        
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationsSelector.updatedApplication, closeFunction, dispatch]);

    const addExam = ()=>{
        let tempPayload = {...schedulePayload}
        tempPayload.scheduledExaminations.push({exam:'', center: application.preferredCenter || ''})
        setSchedulePayload(tempPayload)
    }
    
    const updateSchedule = (index, field, value)=>{
        let tempPayload = {...schedulePayload}
        tempPayload.scheduledExaminations[index][field] = value
        setSchedulePayload(tempPayload)
    }
    
    const removeExam = (index)=>{
        let tempPayload = {...schedulePayload}
        tempPayload.scheduledExaminations.splice(index, 1)
        setSchedulePayload(tempPayload)
    }

    const validateForm = () => {
        let errors = {}

        schedulePayload.scheduledExaminations.forEach((exam, examIndex)=>{
            if(!exam || exam === '') {
                errors[`${examIndex}-exam`] = true
            }
        })

        setValidationErrors(errors)

        return errors
    }

    const pushSchedule = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        dispatch(updateApplication(application._id, schedulePayload))

    }

    // const preSelectedExamCenter = () => {
    //     let selected = ''
    //     if(application.preferredCenter){
    //         selected = application.preferredCenter
    //     }
    // }
    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>{description}</p>
            </div>
            <div className='mt-4 relative'>
                {examinationsSelector?.examinations?.examinations?.length > 0 ? 
                schedulePayload.scheduledExaminations.map((exam, examIndex)=>(
                    <div key={examIndex}>
                        {examIndex > 0 &&
                        <div className="absolute -top-[5px] right-0 w-[20px] flex items-center justify-center">
                            <button onClick={()=>{removeExam(examIndex)}} className='p-1 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <TrashIcon className={`w-5 h-5`} />
                            </button>
                        </div>
                        }

                        <div className='w-full my-2'>
                            <SelectField
                                selectOptions={examinationsSelector?.examinations?.examinations}
                                inputLabel="Select examination"
                                titleField="name"
                                displayImage={false}
                                imageField=""
                                requiredField={true}
                                preSelected={exam || ''}
                                preSelectedIndex={''}
                                preSelectedLabel="_id"
                                fieldId="exam-select"
                                hasError={validationErrors && validationErrors[`${examIndex}-exam`]}
                                // return id of accounts of the selected option
                                returnFieldValue={(value) => {updateSchedule(examIndex, 'examination', value._id)}}
                            /> 
                        </div>

                        {!examinationCentersSelector?.loadingExaminationCenters && examinationCentersSelector?.examinationCenters?.examinationCenters?.length > 0 && <div className='w-full my-2'>
                            <SelectField
                                selectOptions={examinationCentersSelector?.examinationCenters?.examinationCenters}
                                inputLabel="Select examination center"
                                titleField="name"
                                displayImage={false} 
                                imageField=""
                                requiredField={false}
                                preSelectedIndex={examinationCentersSelector?.examinationCenters?.examinationCenters?.findIndex(center => center?._id === application?.preferredCenter?._id)}
                                fieldId="center-select"
                                hasError={false}
                                // return id of accounts of the selected option
                                returnFieldValue={(value) => {updateSchedule(examIndex, 'center', value._id)}}
                            /> 
                        </div>}
                    </div>
                    ))
                : 
                    <div className='w-full bg-gray-100 p-4 rounded text-xs text-red-700 flex items-center justify-center'>
                        <p>There are no examinations yet. To be able to schedule this applicant for an exam, please navigate to "Examinations" on the left sidebar and create the exam first.</p>
                    </div>
                }

                <div className='flex flex-row-reverse'>
                    <button onClick={()=>{addExam()}} className='p-3 mt-3 rounded bg-transparent mb-[10px] bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-sm flex items-center justify-center text-vcm-purple hover:text-vcm-purple'> <PlusIcon className={`w-4 h-4`} /> Add another exam</button>
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Schedule`}
                    buttonAction={()=>{pushSchedule()}}
                    processing={applicationsSelector.updatingApplication}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default NewExaminationSchedule